<script>
import Schedule from '@/components/seller/Schedule'

import { GET_SCHEDULE_QUERY } from '@/graph/gql/user.gql'
import { updateViewer } from '@/graph/mutations/user'

export default {
  name: 'ScheduleView',
  components: { Schedule },
  apollo: {
    schedule: {
      query: GET_SCHEDULE_QUERY,
      fetchPolicy: 'cache-and-network',
      update: data => data.viewer.sellerSchedule,
      result({ data }) {
        if (data) this.updateForm(data.viewer)
      }
    }
  },
  data() {
    return {
      form: {
        status: true,
        schedule: {}
      },
      dirty: false,
      snackbar: false,

      submitting: false,
      errors: {
        status: [],
        schedule: []
      }
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        if (this.dirty && newVal && oldVal) {
          this.submit()
        }
      },
      deep: true
    }
  },
  created() {
    const { throttle } = this.lodash
    this.submit = throttle(this._submit, 1000)
  },
  methods: {
    updateForm(data) {
      if (!data.sellerSchedule) return

      const { status, mon, tue, wed, thu, fri, sat, sun } = data.sellerSchedule
      this.form = { status, schedule: { mon, tue, wed, thu, fri, sat, sun } }
      this.$nextTick(this.submit.cancel)
    },

    showError() {
      // TODO: add error handling
    },

    _submit() {
      if (this.submitting) return
      this.submitting = true

      const { status, schedule } = this.form
      const data = {
        sellerSchedule: { ...schedule, status }
      }

      updateViewer(data)
        .then(result => {
          this.snackbar = true
          this.updateForm(result.updateViewer)
        })
        .catch(this.showError)
        .finally(() => (this.submitting = false))
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Schedule view -->
    <div class="view-grid">
      <div>
        <div class="display-1 font-weight-bold mb-7">
          Schedule
        </div>

        <div class="content-top content-nogutter">
          <div class="mt-3">
            <!-- Subtitle -->
            <div class="body-2 mt-1">
              Buyers will order food at least 24 hours in advance.
            </div>

            <v-layout row mt-4 px-3 align-center>
              <v-flex xs10 class="body-2 font-weight-medium">
                <span :class="{ 'accent--text': form.status === 'PAUSED' }">
                  Take a break (hide my profile)
                </span>
              </v-flex>
              <v-flex xs2>
                <v-switch
                  v-model="form.status"
                  true-value="PAUSED"
                  false-value="ACTIVE"
                  class="sales-status ma-0 pa-0"
                  @change="dirty = true"
                />
              </v-flex>
            </v-layout>

            <!-- Loading -->
            <v-skeleton-loader
              v-if="$apollo.loading"
              class="mx-auto mt-2"
              type="card-heading, paragraph"
            />

            <!-- Seller Schedule -->
            <Schedule
              v-if="!$apollo.loading"
              v-model="form.schedule"
              @input="dirty = true"
            />

            <v-snackbar v-model="snackbar">
              Schedule saved
              <v-btn text @click="snackbar = false">
                Close
              </v-btn>
            </v-snackbar>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="sass">
.sales-status
  .v-input__slot
    margin: 0 !important
  .v-messages
    display: none
</style>
